import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CheckDuplicateEntityPricePolicyQuery,
  DuplicateEntityPricePolicyBody,
  EntityPricePolicyApi,
  FindEntityPricePolicyForSelectQuery,
  FindEntityProposalPolicyForInheritQuery,
  FindOptions,
  UpdateEntityPricePolicyBody,
} from 'api';

export const findEntityPricePolicyWithEntityForTableList = createAsyncThunk(
  'entityPricePolicy/findEntityPricePolicyWithEntityForTableList',
  async (option: FindOptions, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.findWithEntity(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityPricePolicyForMenuShareSelect = createAsyncThunk(
  'entityPricePolicy/findEntityPricePolicyForMenuShareSelect',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.findForMenuShareSelect(
        params
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityPricePolicyForSelectForCreateBillFromOrder =
  createAsyncThunk(
    'entityPricePolicy/findEntityPricePolicyForSelectForCreateBillFromOrder',
    async (params: any, { rejectWithValue }) => {
      try {
        const response =
          await EntityPricePolicyApi.findForSelectForCreateBillFromOrder(
            params
          );

        return response;
      } catch (error: any) {
        if (!error.response) {
          throw error;
        }

        return rejectWithValue(error.response.data);
      }
    }
  );

export const createEntityPricePolicy = createAsyncThunk(
  'entityPricePolicy/createEntityPricePolicy',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityPricePolicyForInherit = createAsyncThunk(
  'entityPricePolicy/findEntityPricePolicyForInherit',
  async (
    option: FindEntityProposalPolicyForInheritQuery,
    { rejectWithValue }
  ) => {
    try {
      const response = await EntityPricePolicyApi.findForInherit(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityPricePolicyForDuplicate = createAsyncThunk(
  'entityPricePolicy/findEntityPricePolicyForDuplicate',
  async (
    option: FindEntityProposalPolicyForInheritQuery,
    { rejectWithValue }
  ) => {
    try {
      const response = await EntityPricePolicyApi.findForDuplicate(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityPricePolicyEntityProductForInherit = createAsyncThunk(
  'entityPricePolicy/findEntityPricePolicyEntityProductForInherit',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.findEntityProductForInherit(
        id
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityPricePolicyEntityProductForDuplicate = createAsyncThunk(
  'entityPricePolicy/findEntityPricePolicyEntityProductForDuplicate',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.findEntityProductForDuplicate(
        id
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityPricePolicy = createAsyncThunk(
  'entityPricePolicy/findEntityPricePolicy',
  async (option: FindOptions, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityPricePolicy = createAsyncThunk(
  'entityPricePolicy/updateEntityPricePolicy',
  async (
    params: { id: string; body: UpdateEntityPricePolicyBody },
    { rejectWithValue }
  ) => {
    try {
      const { id, body } = params;
      const response = await EntityPricePolicyApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityPricePolicyForSelect = createAsyncThunk(
  'entityPricePolicy/findEntityPricePolicyForSelect',
  async (params: FindEntityPricePolicyForSelectQuery, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.findForSelect(params);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityPricePolicyForSelectFromPartner = createAsyncThunk(
  'entityPricePolicy/findEntityPricePolicyForSelectFromPartner',
  async (params: FindEntityPricePolicyForSelectQuery, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.findForSelect(params);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityPricePolicyForSelectInChain = createAsyncThunk(
  'entityPricePolicy/findEntityPricePolicyForSelectInChain',
  async (params: FindEntityPricePolicyForSelectQuery, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.findForSelectInChain(params);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findInheritEntityPricePolicy = createAsyncThunk(
  'entityPricePolicy/findInheritEntityPricePolicy',
  async (params: FindEntityPricePolicyForSelectQuery, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.findInheritEntityPricePolicy(
        params
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityPricePolicy = createAsyncThunk(
  'entityPricePolicy/removeEntityPricePolicy',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.delete(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateEntityPricePolicy = createAsyncThunk(
  'entityPricePolicy/checkDuplicateEntityPricePolicy',
  async (query: CheckDuplicateEntityPricePolicyQuery, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.checkDuplicate(query);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const duplicateEntityPricePolicy = createAsyncThunk(
  'entityPricePolicy/duplicateEntityPricePolicy',
  async (
    params: { id: string; body: DuplicateEntityPricePolicyBody },
    { rejectWithValue }
  ) => {
    try {
      const { id, body } = params;
      const response = await EntityPricePolicyApi.duplicate(id, body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityPricePolicyWithEntity = createAsyncThunk(
  'entityPricePolicy/findOneEntityPricePolicyWithEntity',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityPricePolicyApi.findOneWithEntity(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findApplyEntityInEntityPricePolicy = createAsyncThunk(
  'entityPricePolicy/findApplyEntityInEntityPricePolicy',
  async (id: string, { rejectWithValue }) => {
    try {
      const response =
        await EntityPricePolicyApi.findApplyEntityInEntityPricePolicy(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface InitialState {
  tableList: Array<any>;
  list: Array<any>;
}

const initialState: InitialState = {
  tableList: [],
  list: [],
};

const entityPricePolicySlice = createSlice({
  name: 'entityPricePolicy',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      findEntityPricePolicyForSelect.fulfilled,
      (state, action) => {
        const { data } = action.payload;
        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
          };
        });

        state.list = newData;
      }
    );
  },
});

const { reducer: EntityPricePolicyReducer } = entityPricePolicySlice;

export default EntityPricePolicyReducer;
